/**
* 检查放大缩小可选值的合法性
* @param {*} value 数组，数据由小到大，最小0.1，最大10
例如：[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2.0]
* @returns
*/
export function checkZoomFactors(value) {
  let b = true;
  if (Object.prototype.toString.call(value) == '[object Array]' && value.length) {
    let last = 0;
    for (let i = 0; i < value.length; i++) {
      if (value[i] < 0.1 || value[i] > 10 || value[i] <= last) {
        b = false;
        console.error('不合法的zoomFactors,请填写0.1~10之间的顺序数据数组');
        break;
      } else {
        last = value[i];
      }
    }
  }
  return b;
}

export const isObject = obj => {
  return Object.prototype.toString.call(obj).toLowerCase() === '[object object]';
};
/**
 * 处理取值的边界情况
 * @param {*} leftBoundary 左边界值
 * @param {*} rightBoundary 右边界值
 * @param {*} value 传值
 * @returns
 */
export function getBoundaryValue(leftBoundary, rightBoundary, value) {
  return value > rightBoundary ? rightBoundary : value < leftBoundary ? leftBoundary : value;
}
